// extracted by mini-css-extract-plugin
module.exports = {"base":"ToggleIcon-module-base","switch":"ToggleIcon-module-switch","input":"ToggleIcon-module-input","slider":"ToggleIcon-module-slider"};